module.exports = __webpack_public_path__ + "img/show-attendees.26f17328.jpg";